// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nowrap[data-v-4f2cc48c]{width:1%;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
